import { formatDateDDMMYYYY } from '@genially/utils';

import { useSidebarSummaryWithContentContext } from '../../SidebarSummaryWithContent.context';
import { StyledSmallParagraphDate } from '../../../../SidebarSummary.styled';

export const LastUpdatedInfo = () => {
  const {
    summary: { lastUpdated },
    config: { language },
  } = useSidebarSummaryWithContentContext();

  const lastUpdatedDate = formatDateDDMMYYYY(lastUpdated);
  const lastUpdatedTime = lastUpdated.toLocaleTimeString(language);

  return (
    <StyledSmallParagraphDate>
      {lastUpdatedDate} ({lastUpdatedTime})
    </StyledSmallParagraphDate>
  );
};
